interface Props {
  size?: number
  className?: string
}

export const OffIcon = ({ size = 16, className }: Props) => {
  return (
    <svg
      viewBox="0 0 1037 1024"
      width={size}
      height={size}
      className={className}
    >
      <path
        d="M847.500319 108.773492A517.210065 517.210065 0 1 1 0.000716 507.255535 511.443787 511.443787 0 0 1 189.82229 108.773492a41.581669 41.581669 0 0 1 26.10942-9.455263 40.7221 40.7221 0 0 1 40.363946 40.220684 46.560009 46.560009 0 0 1-17.907696 34.27533 437.234296 437.234296 0 1 0 716.952502 336.987016A441.424697 441.424697 0 0 0 791.520863 169.086611a38.358284 38.358284 0 0 1-11.854895-28.36579 40.686284 40.686284 0 0 1 40.363946-40.184869 34.597668 34.597668 0 0 1 27.291328 8.273356z"
        fill="#ffffff"
      ></path>
      <path
        d="M518.715028 0.002149a40.7221 40.7221 0 0 1 40.363946 40.220684V595.970259a40.363946 40.363946 0 0 1-80.727892 0V40.222833A39.934161 39.934161 0 0 1 518.715028 0.002149z"
        fill="#ffffff"
      ></path>
    </svg>
  )
}
